import { ReactElement, useEffect, useState } from 'react';
import { IMetaLocationClosedDates, IPageLocationFields } from 'types/contentful';
import OfficeDetails, { OfficeHours } from '../OfficeDetails';
import { Add, Remove } from '@material-ui/icons';
import ScheduleAppointmentCta from '../ScheduleAppointmentCta';
import CTA from '../Cta';

interface OfficeLocationCardProps {
  index: number;
  location: IPageLocationFields;
  closedDates: IMetaLocationClosedDates | undefined;
  siteName: string;
  markerIcon: string;
}

export default function OfficeLocationCard({
  index,
  location,
  closedDates,
  siteName,
  markerIcon,
}: OfficeLocationCardProps): ReactElement {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (index === 0) {
      setOpen(true);
    }
  }, [index]);

  const officeInfo = { ...location };

  const locationDetailsCTA = {
    title: 'view-location-details',
    text: 'View Location Details',
    slug: `locations/${location.slug}`,
    linkToAsset: undefined,
    colorScheme: 'OutlinedTeal' as const,
    openInNewTab: false,
  };

  return (
    <div className="bg-muted">
      <div className="flex justify-between items-center p-4 md:px-10 lg:px-16">
        <span className="text-2xl text-primary-actual">{officeInfo.name}</span>
        <button
          onClick={() => setOpen(!open)}
          className="text-secondary-actual focus:outline-none text-4xl"
        >
          {open ? <Remove style={{ fontSize: '60px' }} /> : <Add style={{ fontSize: '60px' }} />}
        </button>
      </div>
      {open && (
        <OfficeDetails
          siteName={siteName}
          officeName={officeInfo.name}
          hideEyeOnPin={true}
          hours={officeInfo.hours as OfficeHours}
          hoursNotes={officeInfo.hoursNotes}
          markerIcon={markerIcon}
          center={{
            lat: officeInfo.map.lat,
            lng: officeInfo.map.lon,
          }}
          closedDates={closedDates}
          officeInfo={officeInfo}
          zoom={10}
        >
          <div className="flex flex-row gap-3 mt-6">
            <ScheduleAppointmentCta
              location={location}
              colorScheme="Primary"
              wrapperClasses=""
              classNames="min-w-cta max-w-300"
            />
            <CTA {...locationDetailsCTA} classNames="" />
          </div>
        </OfficeDetails>
      )}
    </div>
  );
}
